import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Grid from '@mui/material/Grid';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Box from '../Box/Box';
import { useResponsiveFontSize } from '../hooks/responsive';
const useStyles = makeStyles(theme => createStyles({
    preventOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    alignBaseline: {
        alignItems: 'baseline',
    },
}));
function LabelValuePair({ label, value, labelWidth = 6, valueWidth = 6, colFirstAlign = 'left', colSecondAlign = 'left', color = 'backgroundColor', }) {
    const classes = useStyles();
    const fontSize = useResponsiveFontSize();
    return (_jsxs(Grid, { container: true, className: classes.alignBaseline, children: [_jsx(Grid, { item: true, xs: 12, sm: labelWidth, style: { textAlign: colFirstAlign }, children: _jsxs(Box, { component: "b", fontSize: fontSize, color: color, children: [label, ":"] }) }), _jsx(Grid, { item: true, xs: 12, sm: valueWidth, style: { textAlign: colSecondAlign }, children: _jsx(Box, { component: "div", className: classes.preventOverflow, fontSize: fontSize, color: color, children: value }) })] }));
}
export default LabelValuePair;
